import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { MdsConfig } from '@maersk-global/mds-config';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

declare global {
  interface Window {
    RUM: any;
  }
}

MdsConfig.iconsDynamicImportPath = '/';

function waitForRUMScript(): Promise<void> {
  return new Promise((resolve) => {
    if (window.RUM) {
      resolve();
      return;
    }

    const checkRUM = () => {
      if (window.RUM) {
        resolve();
      } else {
        setTimeout(checkRUM, 100);
      }
    };

    setTimeout(checkRUM, 100);

    setTimeout(() => {
      console.warn('RUM script failed to load within 5 seconds');
      resolve();
    }, 5000);
  });
}

function initializeRUM(): void {
  try {
    if (window.RUM && environment.config.RUM_API_KEY && environment.config.RUM_API_KEY !== 'RUM_API_KEY_PLACEHOLDER') {
      window.RUM.RumInit({
        app: {
          name: environment.config.APP_NAME,
          version: "1.0.0"
        },
        traceLog: true,
        useSendBeacon: true,
        interactions: true,
        console: true,
        apiKey: environment.config.RUM_API_KEY,
      });
    }
  } catch (error) {
    console.error('Error initializing RUM:', error);
  }
}

function waitForToken(): Promise<void> {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const token = sessionStorage.getItem('accessToken');
      if (token) {
        clearInterval(interval);
        resolve();
      }
    }, 100);

    // Timeout: still allow bootstrap after 3s
    setTimeout(() => {
      clearInterval(interval);
      resolve();
    }, 3000);
  });
}

waitForRUMScript()
  .then(() => {
    initializeRUM();
    return waitForToken();
  })
  .then(() => {
    bootstrapApplication(AppComponent, appConfig)
      .catch((err) => console.error(err));
  });
